import * as Headless from "@headlessui/react";
import clsx from "clsx";
import { ReactElement } from "react";

export const SwitchField = ({
  className,
  ...props
}: { className?: string } & Omit<
  Headless.FieldProps,
  "as" | "className"
>): ReactElement => (
  <Headless.Field
    data-slot="field"
    {...props}
    className={clsx(
      className,
      // Base layout
      "grid grid-cols-[1fr_auto] items-center gap-x-8 gap-y-1 sm:grid-cols-[1fr_auto]",
      // Control layout
      "[&>[data-slot=control]]:col-start-2 [&>[data-slot=control]]:self-center",
      // Label layout
      "[&>[data-slot=label]]:col-start-1 [&>[data-slot=label]]:row-start-1 [&>[data-slot=label]]:justify-self-start",
      // Description layout
      "[&>[data-slot=description]]:col-start-1 [&>[data-slot=description]]:row-start-2",
      // With description
      "[&_[data-slot=label]]:has-[[data-slot=description]]:font-medium",
    )}
  />
);
